/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMoeV2IconLinkMenuViewProps } from './moe-v2-icon-link-menu';

export default (props: IMoeV2IconLinkMenuViewProps) => {
    const {
        columnCount = 'two',
        iconStyle = 'roundedBlock',
        iconColor = '#1976d2',
        listItems = [],
        heading,
        headingSize = 'h2',
        headingTopPadding = '0rem',
        headingBottomPadding = '0rem',
        moduleLeftRightPadding = '0rem'
    } = props.config;
    const columnClass = `columns-${columnCount}`;

    const renderIcon = (item: any) => {
        const color = item.color || iconColor;
        switch (iconStyle) {
            case 'roundedBlock':
                return <div className='icon-square rounded' style={{ backgroundColor: color }} />;
            case 'line':
                return <div className='icon-vertical-line' style={{ borderColor: color, backgroundColor: color }} />;
            case 'imageSquare':
                return (
                    <div className='icon-square rounded'>
                        {item.iconImage && item.iconImage.src ? (
                            <img
                                src={item.iconImage.src}
                                alt={item.linkName || 'Icon'}
                                onError={e => {
                                    // Hide image on error and show fallback
                                    e.currentTarget.style.display = 'none';
                                }}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                        ) : (
                            // Fallback when no image is available
                            <div className='icon-placeholder' style={{ backgroundColor: color }} />
                        )}
                    </div>
                );
            default:
                return <div className='icon-square' style={{ backgroundColor: color }} />;
        }
    };
    return (
        <div
            style={{
                paddingTop: `${headingTopPadding}`,
                paddingLeft: moduleLeftRightPadding,
                paddingRight: moduleLeftRightPadding
            }}
            className='moe-v2-module-container moe-v2-icon-link-menu'
        >
            {(() => {
                const HeadingTag = headingSize ? (`${headingSize}` as keyof JSX.IntrinsicElements) : 'h2';
                return (
                    <HeadingTag style={{ paddingBottom: headingBottomPadding }} className='moe-main-menu-heading'>
                        {heading}
                    </HeadingTag>
                );
            })()}
            <div className={`custom-list ${columnClass}`}>
                {listItems.map((item, idx) => {
                    const RowContent = (
                        <div className='list-item-row'>
                            {renderIcon(item)}
                            <div className='content-wrapper'>
                                <span className='link-name' title={item.linkName}>
                                    {item.linkName}
                                </span>
                            </div>
                            <span className='arrow-wrapper'>
                                <span className='arrow-icon'>→</span>
                            </span>
                        </div>
                    );
                    return item.link ? (
                        <a key={idx} className='menu-link' href={item.link.destinationUrl} tabIndex={0} aria-label={item.linkName}>
                            {RowContent}
                        </a>
                    ) : (
                        <div key={idx}>{RowContent}</div>
                    );
                })}
            </div>
        </div>
    );
};
